$(".slick-desktop .js-carousel-items").slick({
  infinite: true,
  slidesToShow: 3,
  arrows: false,
  dots: false,
  autoplay: true,
  autoplaySpeed: 2000,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 480,
      settings: "unslick",
    },
  ],
});
$(".new-arrivals .js-carousel-items, .best-sellers .js-carousel-items").slick({
  infinite: true,
  slidesToShow: 4,
  arrows: true,
  dots: false,
  autoplay: false,
  autoplaySpeed: 2000,
  slidesToScroll: 1,
  prevArrow:
    '<button class="slide-arrow prev-arrow"><i class="fa-solid fa-chevron-left"></i></button>',
  nextArrow:
    '<button class="slide-arrow next-arrow"><i class="fa-solid fa-chevron-right"></i></button>',
  responsive: [
    {
      breakpoint: 480,
      settings: {
        centerMode: true,
        centerPadding: "10%",
        slidesToShow: 1,
      },
    },
  ],
});
$(".logo-slider .rw.gap-equal").slick({
  infinite: true,
  slidesToShow: 4,
  arrows: false,
  dots: false,
  autoplay: true,
  autoplaySpeed: 1000,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 480,
      settings: "unslick",
    },
  ],
});
$(document).ready(function () {
  $(".proud-slider").slick({
    vertical: true,
    verticalSwiping: true,
    focusOnSelect: true,
    // centerMode: true,
    arrows: false,
    pauseOnHover: false,
    dots: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 2000,
  });
});
$(".industry-slider-1").slick({
  arrows: false,
  pauseOnHover: false,
  dots: false,
  slidesToShow: 3,
  slidesToScroll: 1,
  infinite: true,
  autoplay: true,
  autoplaySpeed: 2000,
  centerMode: true,
  centerPadding: "60px",
  responsive: [
    {
      breakpoint: 570,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
      },
    },
  ],
});

$(".industry-slider-2").slick({
  rtl: true,
  arrows: false,
  pauseOnHover: false,
  dots: false,
  slidesToShow: 3,
  slidesToScroll: 1,
  infinite: true,
  autoplay: true,
  autoplaySpeed: 2000,
  centerMode: true,
  centerPadding: "60px",
  responsive: [
    {
      breakpoint: 570,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
      },
    },
  ],
});

$(".slider-nav").slick({
  slidesToShow: 7,
  slidesToScroll: 1,
  asNavFor: ".testimonial_card_wrapper",
  dots: false,
  arrows: false,
  centerMode: true,
  focusOnSelect: true,
  responsive: [
    {
      breakpoint: 570,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
      },
    },
  ],
});
$(".testimonial_card_wrapper").slick({
  arrows: true,
  prevArrow:
    "<button type='button' class='slick-prev slick-left'><i class='fa-solid fa-arrow-right-long' aria-hidden='true'></i></button>",
  nextArrow:
    "<button type='button' class='slick-next  slick-right'><i class='fa-solid fa-arrow-left-long' aria-hidden='true'></i></button>",
  pauseOnHover: false,
  dots: false,
  slidesToShow: 1,
  slidesToScroll: 1,
  infinite: true,
  autoplay: false,
  autoplaySpeed: 2000,
  asNavFor: ".slider-nav",
  responsive: [
    {
      breakpoint: 570,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
});
// parallax
$(document).ready(function () {
  var container = $(".hero-banner .js-carousel-items");

  $(window).scroll(function () {
    if (window.innerWidth > 768) {
      var scrollY = $(window).scrollTop();
      var translateY = scrollY * 0.3;

      // Apply the transform to each parallax item
      container.find(".js-carousel-item").each(function () {
        $(this).css("transform", "translateY(" + -translateY + "px)");
      });

      // Adjust the height of the container dynamically
      // var containerHeight = 100 - translateY * 0.5;
      // $(".hero-banner .s-content").css("height", containerHeight + "vh");
    }
  });
});

// READ MORE BTN
$(document).ready(function () {
  var content = $(".s-header__desc");
  var toggleButton = $("#readMore");

  toggleButton.click(function () {
    content.toggleClass("expanded");

    var isExpanded = content.hasClass("expanded");
    toggleButton.text(isExpanded ? "See Less" : "Read More");
  });
});
